var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { LIB_VERSION } from "../version";
export function loadSceneConfig(input) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    // Use prod cdn if an environment is not specified
    const environment = ((_a = input.settings) === null || _a === void 0 ? void 0 : _a.environment) === "dev" ? "dev." : "cdn.";
    const params = new URLSearchParams();
    params.set("sceneUri", input.sceneUrl);
    params.set("imageFormat", (_c = (_b = input.settings) === null || _b === void 0 ? void 0 : _b.imageFormat) !== null && _c !== void 0 ? _c : "png");
    params.set("quality", (_e = "".concat((_d = input.settings) === null || _d === void 0 ? void 0 : _d.imageQuality)) !== null && _e !== void 0 ? _e : "85");
    params.set("warpFormat", "customPngRRGG32");
    params.set("version", LIB_VERSION);
    // Disable UV Maps for now because the visual results are not great
    params.set("disableUVMaps", "true");
    const url = "https://".concat(environment, "scenes.documents.cimpress.io/v3/compilescene?").concat(params.toString());
    const response = yield fetch(url);
    if (!response.ok) {
      let text = "".concat(response.url, " returned status code: ").concat(response.status);
      try {
        const jsonError = yield response.json();
        if (jsonError.message) {
          text = jsonError.message;
        }
      } catch (_f) {
        // Silent catch
      }
      throw new Error(text);
    }
    return yield response.json();
  });
}
export function loadImageAsset(assetUrl) {
  return __awaiter(this, void 0, void 0, function* () {
    if (assetUrl) {
      const response = yield fetch(assetUrl);
      const blob = yield response.clone().blob();
      return yield createImageBitmap(blob);
    }
    return undefined;
  });
}